"use strict";
/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @constant
 * @function
 * PolyFills Promise and fetch after checking for its availability in native
 * @returns Nothing
 */
exports.init = function () {
    require("es6-promise").polyfill();
    require("isomorphic-fetch");
};
//# sourceMappingURL=PolyFill.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@microsoft/microsoft-graph-client/lib/src/PolyFill.js
// module id = /QM5
// module chunks = 0